const de = {
  notificationClass: 'swiper-notification',
  prevSlideMessage: 'Vorheriger Inhalt',
  nextSlideMessage: 'Nächster Inhalt',
  firstSlideMessage: 'Erster Inhalt',
  lastSlideMessage: 'Letzter Inhalt',
  paginationBulletMessage: 'Zeige Karussellinhalt {{index}}',
  slideLabelMessage: 'Inhalt {{index}} von {{slidesLength}}',
  containerMessage: null,
  containerRoleDescriptionMessage: 'Inhaltskarussell',
  itemRoleDescriptionMessage: null,
  skipLinkMessage: 'Inhaltskarussel überspringen',
  counterClass: 'swiper-a11y-counter',
  counterMessage: 'Inhalt {{index}} von {{slidesLength}}',
};

export { de };
